import { FuseRouteItemType } from '@fuse/utils/FuseUtils';
import { lazy } from 'react';

const Onboarding = lazy(() => import('./Onboarding'));

const OnboardingRoute: FuseRouteItemType[] = [
  {
    path: '/onboarding',
    element: <Onboarding />,
    settings: {
      layout: {
        config: {
          toolbar: {
            title: 'Onboarding',
            ignoreHome: true,
            showCrumbs: false,
          }
        }
      }
    }
  }
];

export default OnboardingRoute;
